import { ReactNode } from 'react';
import { Address } from '../../utils/checkoutState';
import { joinStreetHouseNumber, joinZipCodeCity } from '../../utils/streetHouseNumber';

const FormattedAddress = ({ address, title }: { address: Address; title?: ReactNode }) => {
  const { firstName, lastName, additional, collectionPoint } = address;
  return (
    <dl>
      {title}
      <dd>{!collectionPoint ? `${firstName} ${lastName}` : collectionPoint.description}</dd>
      {additional && <dd>{additional}</dd>}
      <dd>{joinStreetHouseNumber(address)}</dd>
      <dd>{joinZipCodeCity(address)}</dd>
    </dl>
  );
};

export default FormattedAddress;
